import React, { FC } from 'react';
import { createFeature } from '@edreamsodigeo/frontend-core';
import { colors } from './constants/designTokens';
import { useFlowTools } from 'flowTools/useFlowTools';
import { MoneyComponent } from '../../../Shared/Money';
import { DEAL_PRICE_MOBILE } from 'clientState/ab/aliases';

const PRICE_COLOR = colors.deal.priceColor;

type DealPriceProps = {
  price: {
    amount: number;
    currency: string;
  };
};

const DealPriceRegular: FC<DealPriceProps> = ({ price }) => (
  <MoneyComponent size="medium" currency={price.currency} strikeThrough="none">
    {price.amount}
  </MoneyComponent>
);

const DealPriceRed: FC<DealPriceProps> = ({ price }) => (
  <MoneyComponent
    size="medium"
    currency={price.currency}
    strikeThrough="none"
    sx={{
      '.money-integer': { color: PRICE_COLOR },
      '.money-fraction': { color: PRICE_COLOR },
      '.money-currency': { color: PRICE_COLOR },
    }}
  >
    {price.amount}
  </MoneyComponent>
);

const DealPrice: FC<DealPriceProps> = ({ price }) => {
  const { isDesktop } = useFlowTools();
  return isDesktop ? (
    <DealPriceRed price={price} />
  ) : (
    <DealPriceMobile price={price} />
  );
};

const DealPriceMobile = createFeature({
  name: DEAL_PRICE_MOBILE,
  variations: [DealPriceRegular, DealPriceRed, DealPriceRed],
  version: 1,
});

export default DealPrice;
